<template lang="pug">
  .product-details.grid.col-2
    .left-area
      slot(name="header")
      BreadcrumbNav
      main(:class="{ 'has-sub-menu': visibleCurrentLevelMenu }")
        .shop-menu-current-level(
          v-if="visibleCurrentLevelMenu"
          :style="{ width: width ? `${width}px` : null }"
        )
          affix.sticky-stuff(
            ref="sticky-nav"
            relative-element-selector="#product-page-sections"
            :scroll-affix="true"
            :offset="{ top: 15, bottom: 15 }"
          )
            nav(ref="nav")
              tree-menu(
                :items="currentLevelItems"
                :active-ids="activeMenuItemIDs"
                :max-depth="3"
                :delay="400"
              )
        #product-page-sections(
          ref="sections"
        )
          Spinner(v-if="loading" :size="10" :thickness="2")
          section.details(v-else-if="product" key="details")
            ProductPreview(
              :product="product"
              :active="true"
              display="preorder"
            )
          .not-found(v-else key="not-found")
            Error.error(:code="404" message="Produkt konnte nicht gefunden werden")
    .right-area.video(v-if="currentVideo")
      Video(
        :data="currentVideo"
        :key="currentVideo.id"
      )
    .right-area.image(v-else-if="currentImage")
      Graphic(
        :data="currentImage"
        :title="product.name"
        :key="currentImage.id"
      )
    //- empty placeholder
    .right-area.placeholder(v-else)
      //- .fixed NO MEDIA

    //- CartRow
    //- //- slot(name="footer")
    Footer
</template>

<script>
// import uniqid from 'uniqid';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { get, cloneDeep } from '@/helpers';
// import { moneyFormat } from '@/filters';

import Error from '@/components/Error';

import NestedSet from '@/nested-set-lib';
import SetupAPI from '@/store/api/setup.js';

import Footer from '@/components/Footer.vue';
import CartRow from '@/extensions/shop/components/CartRow';
import ProductPreview from '@/extensions/shop/components/LazyCategoryProducts/Partials/ProductPreview';
import BreadcrumbNav from '@/components/BreadcrumbNav';
import Video from '@/extensions/shop/components/Video';
import Graphic from '@/extensions/shop/components/Graphic';

export default {
  name: 'ProductDetailPage',
  data: () => ({
    loading: false,
    product: undefined,
    m: 0, // active media key
    selectedOptions: {}, // key is property id
    qty: 1,

    width: undefined
  }),
  components: {
    Error,
    BreadcrumbNav,
    ProductPreview,
    Video,
    Graphic,
    CartRow,
    Footer
  },
  computed: {
    currentMedia() {
      let media;
      if (this.product?.media?.length) {
        // get the "main" media object (is marked for list view)
        // media = this.activeProduct.media.find(el => get(el, 'settings.show.list', true) === true);

        media = this.product.media.find(el => {
          return get(el, 'settings.show.detail', true) === true;
        });
      }

      return media;
    },
    currentVideo() {
      let video;
      if (this.focusedMedia) {
        if (this.focusedMedia.type === 'video') video = this.focusedMedia.video;
      } else if (this.currentMedia && this.currentMedia.type === 'video') {
        video = this.currentMedia.video;
      }
      return video;
    },
    currentImage() {
      let image;
      if (this.focusedMedia) {
        if (this.focusedMedia.type === 'image') image = this.focusedMedia.image;
      } else if (this.currentMedia && this.currentMedia.type === 'image') {
        image = this.currentMedia.image;
      }
      return image;
    },
    currentLevelItems() {
      let tree;
      if (this.activeMenuItemIDs && this.activeMenuItemIDs.length) {
        let items = [];
        const menu = this.menus.find(menu => menu.key === 'main-menu');
        items = get(menu, 'menuItems') || [];
        items = cloneDeep(items);

        if (this.activeMenuItemIDs.length >= 2) {
          const parentID = this.activeMenuItemIDs[this.activeMenuItemIDs.length - 2];
          if (items.length) {
            const target = items.find(el => el.id === parentID);
            if (target) {
              tree = NestedSet.createTree(items, target._lft, target._rgt);
            }
          }
        } else {
          const rootID = this.activeMenuItemIDs[0];
          if (items.length) {
            const full = NestedSet.createTree(items);
            if (full && full.length) {
              const item = full.find(el => el.id === rootID);
              if (item && item.children && item.children.length) tree = item.children;
            }
          }
        }
      }

      return tree;
    },
    visibleCurrentLevelMenu() {
      const items = this.currentLevelItems || [];
      return items.filter(item => !item.disabled && !item.hidden).length > 0;
    },
    activeMenuItemIDs() {
      let IDs = [];

      const menus = this.menus || [];
      const menu = menus.find(menu => menu.key === 'main-menu');
      const items = get(menu, 'menuItems') || [];

      let item;
      let path = '/';

      const history = SetupAPI.getRouteHistory();
      if (history.length) {
        history.forEach(path => {
          if (item) return;
          item = items.find(el => el.path === path);
        });
      } else {
        item = items.find(el => el.path === path);
      }

      if (item) {
        const ancestors = NestedSet.getAncestors(cloneDeep(items), item);
        IDs = [...ancestors, item].map(el => el.id);
      }

      return IDs;
    },
    ...mapGetters({
      menus: 'menus',
      focusedMedia: 'shop/focusedMedia',
      widescreen: 'shop/widescreen',
      tailwind: 'tailwind'
    })
  },
  methods: {
    ...mapMutations({
      setProduct: 'shop/setProduct',
      setWidescreen: 'shop/setWidescreen'
    }),
    ...mapActions({
      addMessage: 'message/add',
      fetchProduct: 'shop/fetchProduct'
    })
  },
  mounted() {
    this.loading = true;

    this.fetchProduct({ slug: this.$route.params.product })
      .then(product => {
        this.product = product;
      })
      .finally(() => {
        this.loading = false;
      });

    const widescreen = get(
      this.tailwind.theme.screens.widescreen.raw.match(/min-aspect-ratio: (?<w>[1-9]+?[0-9]*)\/(?<h>[1-9]+?[0-9]*)/),
      'groups'
    );
    const ratio = parseFloat(widescreen.w) / parseFloat(widescreen.h);
    const lg = parseInt(this.tailwind.theme.screens.lg);

    const checkWidescreen = () => {
      const widescreen = window.innerWidth / window.innerHeight >= ratio && window.innerWidth >= lg;
      if (widescreen !== this.widescreen) this.setWidescreen(widescreen);

      // TODO
      // find the reason for this nasty workaround
      this.$nextTick(() => {
        if (this.$refs.nav) {
          if (window.innerWidth >= lg) this.width = this.$refs.nav.clientWidth;
        }
      });
    };

    // window.addEventListener('resize', debounce(checkWidescreen, 100));
    window.addEventListener('resize', checkWidescreen);
    setTimeout(checkWidescreen, 150);
    // checkWidescreen();
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.product-details
  flex-grow: 1
  width: 100%
  @screen widescreen
    @screen lg
      grid-template-rows: auto
      grid-template-columns: minmax(0, $leftWidth) $rightWidth
  .left-area
    min-height: 100vh
    max-width: 100%
    display: flex
    flex-direction: column
    @screen lg
      padding-bottom: 51px
    section, .items
      display: flex
      flex-direction: column
      flex-grow: 1
      // min-height: 100%
  .right-area
    display: none
    @screen widescreen
      @screen lg
        display: flex
        // padding-bottom: 51px
        background: #fff
        border-left: 1px solid #d7d7d7
        // background: var(--color-primary)
        &.video::v-deep
          .video-container
            // padding: 1rem
            width: $rightWidth
        &.image::v-deep
          .graphic
            padding: 1rem
            width: $rightWidth
            .image
              width: calc(#{$rightWidth} - 2rem)
        &.placeholder .fixed
          @apply text-gray-700 flex items-center justify-center
          width: $rightWidth
          height: 100vh
          padding-bottom: 51px
  main
    display: flex
    // flex-direction: row
    flex-grow: 1
    padding: 1rem
    @screen lg
      padding: 1rem 3rem
      //- @screen widescreen
      //-   padding-right: 10rem
      &.has-sub-menu
        display: grid
        grid-template-rows: 100%
        grid-template-columns: max-content minmax(0, 100%)
        grid-gap: 1rem
    .shop-menu-current-level
      display: none
      @screen lg
        display: initial
      nav > ul.tree-menu
        display: flex
        flex-direction: column
        &::v-deep
          & > li
            display: inline-block
            width: auto
            max-width: 180px
            margin-bottom: 3px
            &.hover
              @apply outline-black-sm
            & > .tree-item > a
              width: 100%
              // padding: 4px 6px 6px
              border: 1px solid var(--color-primary)
              // display: inline-block
              // line-height: 1
              text-align: left
              // font-weight: bold
              // transition: background .15s ease, color .15s ease
            &.active > .tree-item > a
              color: white !important
              background: black
            ul.tree-menu
              position: absolute
              left: 100%
              top: 0
              padding-left: 2px
              z-index: 4
              li + li
                margin-top: 2px
            .tree-item > a
              display: block
              line-height: 1
              padding: 4px 6px 4px
              font-weight: bold
              transition: background .15s ease, color .15s ease
          li
            position: relative
    #product-page-sections
      @apply flex flex-grow flex-col
      width: 100%
</style>
